import React, {Component} from 'react';
import {withTranslation} from 'react-i18next';
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import {ChannelAccountSelect} from '../../selects/ChannelAccountSelect';
import {ChannelLogo} from '../../channels/ChannelLogo';
import {CHANNEL_INFO_BY_CHANNEL} from '../../channels/channels';
import {APIClient} from '../../../utils/APIClient';
import {API_URL} from '../../../settings/local_settings';
import {Spinner} from '../../Spinner';

class QuickConnectAccountModalClass extends Component {
    constructor(props) {
        super(props);
        this.state = {
            accounts: null,
            loading: true,
            saving: false,
            error: null,
        };
        this.handleAccountChange = this.handleAccountChange.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (this.props.isOpen && !prevProps.isOpen && this.props.channel) {
            this.fetchAccounts();
        }
        if (!this.props.isOpen && prevProps.isOpen) {
            this.setState({accounts: null, loading: true, saving: false, error: null});
        }
    }

    fetchAccounts() {
        this.setState({loading: true, error: null});
        new APIClient(API_URL + 'get-accounts/' + this.props.channel).call('GET').then((data) => {
            if (data && data.status === 'OK') {
                this.setState({accounts: data.data, loading: false});
            } else {
                this.setState({accounts: [], loading: false, error: data ? data.error_message : 'Error'});
            }
        });
    }

    handleAccountChange(accountId, accountName) {
        const {t} = this.props;
        this.setState({saving: true, error: null});
        const body = {
            channel: this.props.channel,
            account_id: accountId,
            daily_limit_type: null,
            daily_limit_currency: null,
            daily_limit_value: null,
        };
        new APIClient(API_URL + 'client/' + this.props.clientId + '/ad_account/add').call('POST', body).then((data) => {
            this.setState({saving: false});
            if (data && data.status === 'OK') {
                this.props.onSuccess();
                this.props.toggle();
            } else {
                this.setState({error: data ? data.error_message : t('common.error')});
            }
        });
    }

    render() {
        const {t, isOpen, toggle, channel} = this.props;
        const {accounts, loading, saving, error} = this.state;

        if (!channel) return null;

        const channelInfo = CHANNEL_INFO_BY_CHANNEL[channel];
        const channelName = channelInfo ? channelInfo.Spanish : channel;

        return (
            <Modal isOpen={isOpen} toggle={toggle}>
                <ModalHeader toggle={toggle}>
                    <ChannelLogo channel={channel} height={20} width={20} hspace={0} vspace={0}/>
                    {' '}{t('control_central.platforms_connect_title', {channel: channelName})}
                </ModalHeader>
                <ModalBody>
                    <div className="modal-section">
                        {loading && (
                            <div style={{display: 'flex', justifyContent: 'center', padding: '2em 0'}}>
                                <Spinner color="positive"/>
                            </div>
                        )}
                        {!loading && !saving && (
                            <ChannelAccountSelect
                                allAccounts={accounts}
                                selectedAccount={null}
                                onAccountChange={this.handleAccountChange}
                                channel={channel}
                                canCreateNewAccount={false}
                            />
                        )}
                        {saving && (
                            <div style={{display: 'flex', justifyContent: 'center', padding: '2em 0'}}>
                                <Spinner color="positive"/>
                            </div>
                        )}
                        {error && <p className="text-danger" style={{marginTop: '1em'}}>{error}</p>}
                    </div>
                </ModalBody>
                <ModalFooter>
                    <div style={{width: '100%', textAlign: 'center'}}>
                        <span style={{fontSize: '0.85em', color: '#B6B6B7'}}>
                            {t('control_central.platforms_connect_not_found')}{' '}
                            <a href={`/agency/conections`} target="_blank" rel="noopener noreferrer"
                               style={{fontWeight: 600}}>
                                {t('control_central.platforms_connect_go_connections')} &rarr;
                            </a>
                        </span>
                    </div>
                </ModalFooter>
            </Modal>
        );
    }
}

export const QuickConnectAccountModal = withTranslation()(QuickConnectAccountModalClass);
